import palette from '@lib/core/src/theme/palette';
import { IconButton, Stack, Tab as MuiTab, Tabs as MuiTabs, styled } from '@mui/material';
import { RiCloseLine } from '@remixicon/react';

import { TabTitle } from './MeetingDataStyles';

interface TabsProps {
  tabIndex: number;
  onTabChange: (event: React.SyntheticEvent, newValue: number) => void;
  sharedMeeting?: boolean;
  onClose: () => void;
}

const Tab = styled(MuiTab)({
  minHeight: '30px',
  padding: '0 16px',
  justifyContent: 'flex-start'
});

const TabsContainer = styled(Stack)({
  width: '100%',
  position: 'relative',
  flexDirection: 'row',
  justifyContent: 'space-between'
});

const BottomBorder = styled(Stack)({
  width: '100%',
  borderBottom: `2px solid ${palette.grey[1200]}`,
  position: 'absolute'
});

const Tabs = ({ tabIndex, onTabChange, sharedMeeting = false, onClose }: TabsProps) => (
  <Stack alignItems="flex-end" direction="row">
    <TabsContainer>
      <MuiTabs
        sx={{
          minHeight: 'unset',
          '& .MuiTab-root': { color: palette.grey[400] },
          '& .MuiTab-root.Mui-selected': { color: palette.black, fontWeight: 'bold' },
          '& .MuiTabs-indicator': {
            zIndex: 1,
            backgroundColor: palette.black
          }
        }}
        value={tabIndex}
        onChange={onTabChange}
      >
        <Tab label={<TabTitle>Transcript</TabTitle>} />
        {!sharedMeeting && <Tab label={<TabTitle>My Tasks</TabTitle>} />}
      </MuiTabs>
    </TabsContainer>
    <IconButton sx={{ display: { xs: 'flex', md: 'flex', lg: 'none' } }} onClick={onClose}>
      <RiCloseLine />
    </IconButton>
    <BottomBorder />
  </Stack>
);

export default Tabs;
